import { Box, Flex, Link } from '@chakra-ui/react';
import { LucideArrowRight } from 'lucide-react';

const UserForm = () => {
  return (
    <Box p={16}>
      <Flex justify='space-between' align='center'>
        <Box>Please visit v4 for the updated user management interface.</Box>
        <Link
          href='https://rnd.council.nyc.gov/iwomm/account/profile'
          cursor='pointer'>
          Go now <LucideArrowRight />
        </Link>
      </Flex>
    </Box>
  );
};

export default UserForm;
